import { OWN_KIND } from '../features/connection-form/model/settings'
import { OWN_CASHIERS_CAPABILITY, OWN_CATALOG_CAPABILITIES, OWN_DELIVERY_CAPABILITY, OWN_SALE_CAPABILITY, OWN_WINDOWS } from './registerWindows'

/**
 * Входы в окна «Собственной» из карточки ресурса Platform: РМК, своя номенклатура и её цены — как «Товары» и «Цены» у базы 1С.
 * Объект той же формы, что `ResourceEntriesExtension` пакета `platform-ui` (пакеты друг друга не импортируют; совместимость
 * проверяет компилятор в `apps/web`). Право — то, без которого окно ничего не покажет; кнопка его только отражает.
 */
export const ownResourceEntries = {
  kind: OWN_KIND,
  entries: [
    { window: OWN_WINDOWS.sale, label: 'РМК', capability: OWN_SALE_CAPABILITY },
    { window: OWN_WINDOWS.products, label: 'Товары', capability: OWN_CATALOG_CAPABILITIES.catalogRead },
    { window: OWN_WINDOWS.prices, label: 'Цены', capability: OWN_CATALOG_CAPABILITIES.pricesRead },
    { window: OWN_WINDOWS.delivery, label: 'Доставка', capability: OWN_DELIVERY_CAPABILITY },
    { window: OWN_WINDOWS.cashiers, label: 'Кассиры', capability: OWN_CASHIERS_CAPABILITY },
  ],
} as const
